import{d as t}from"./chunk-QTRVW56Z.js";import{b as o}from"./chunk-7IJU7BS3.js";import{m as e}from"./chunk-HBP5N4FR.js";e();var v=()=>{let r=t(),c=o(r);return{provider:r,providerType:c}};export{v as a};
//# sourceMappingURL=chunk-L7Y6N3AF.js.map
